import { AdminPageShell } from "@/components/shared/admin-page-shell";
import { UserFormPage } from "@/features/users/components/UserFormPage";

export default function UsersNewPage() {
  return (
    <AdminPageShell
      title="إضافة مستخدم"
      description="إنشاء حساب مستخدم جديد وإرسال دعوة عبر البريد الإلكتروني لتعيين كلمة المرور"
    >
      <UserFormPage />
    </AdminPageShell>
  );
}
